import { request } from "../../proto/bundle";
import { getConnectionPool } from "../../core/connectionPool";
import { checkMigrate } from "../../init/sdkInit";

export class Team{
    constructor(
        private name: string,
        private roles: string[]
    ) { }

    public getName(): string {
        return this.name;
    }
    public setName(name: string): void {
        this.name = name;
    }
    public getRoles(): string[] {
        return this.roles;
    }
    public setRoles(roles: string[]): void {
        this.roles = roles;
    }

    public static async addTeam(
        name: string,
        roles: string[]
    ) {
        const addTeam = request.AddTeam.create({name, roles})
        const req = request.Request.create({id: null, reqCreateTime: Date.now(), addTeam})
        const pool = await getConnectionPool()
        const resp = await pool.sendAndWait(req)
        checkMigrate(resp.addTeam.status)

        if (resp?.addTeam?.status !== 0) {
            throw new Error(resp?.addTeam?.message??"Failed to add team")
        }
    }

    public static async removeTeam(
        name: string
    ) {
        const removeTeam = request.RemoveTeam.create({name})
        const req = request.Request.create({id: null, reqCreateTime: Date.now(), removeTeam})
        const pool = await getConnectionPool()
        const resp = await pool.sendAndWait(req)
        checkMigrate(resp.removeTeam.status)

        if (resp?.removeTeam?.status !== 0) {
            throw new Error(resp?.removeTeam?.message??"Failed to add team")
        }
    }

    public static async updateTeam(
        name: string,
        roles: string[]
    ) {
        const updateTeam = request.UpdateTeam.create({name, roles})
        const req = request.Request.create({id: null, reqCreateTime: Date.now(), updateTeam})
        const pool = await getConnectionPool()
        const resp = await pool.sendAndWait(req)
        checkMigrate(resp.updateTeam.status)

        if (resp?.updateTeam?.status !== 0) {
            throw new Error(resp?.updateTeam?.message??"Failed to update team")
        }
    }

    public static async getTeam(
        name: string
    ): Promise<Team> {
        const getTeam = request.GetTeam.create({name})
        const req = request.Request.create({id: null, reqCreateTime: Date.now(), getTeam})
        const pool = await getConnectionPool()
        const resp = await pool.sendAndWait(req)
        checkMigrate(resp.getTeam.status)

        if (resp?.getTeam?.status !== 0) {
            throw new Error(resp?.getTeam?.message??"Failed to get team")
        }

        if (resp?.getTeam?.team == null || resp?.getTeam?.team == undefined) {
            throw new Error("No team value returned")
        }

        const team = request.Team.decode(resp?.getTeam?.team)
        return Promise.resolve(new Team(team.name, team.roles))
    }

    public static async listTeamNames(

    ) : Promise<string[]>{
        let listTeams = request.ListTeams.create({})
        let req = request.Request.create({id: null, reqCreateTime: Date.now(), listTeams})
        let pool = await getConnectionPool()
        let resp = await pool.sendAndWait(req)
        checkMigrate(resp.listTeams.status)

        if (resp?.listTeams?.status !== 0){
            throw new Error(resp?.listTeams?.message??"List teams failed!!!")
        }

        return resp?.listTeams?.teams??[]
    }

    public static async listTeams(

    ) : Promise<Team[]>{
        let listTeams = request.ListTeams.create({})
        let req = request.Request.create({id: null, reqCreateTime: Date.now(), listTeams})
        let pool = await getConnectionPool()
        let resp = await pool.sendAndWait(req)
        checkMigrate(resp.listTeams.status)

        if (resp?.listTeams?.status !== 0){
            throw new Error(resp?.listTeams?.message??"List teams failed!!!")
        }

        const teamsList = resp?.listTeams?.teams??[]
        let teamsTeam: Team[] = []
        for (const team of teamsList) {
            teamsTeam.push(await this.getTeam(team))
        }

        return teamsTeam;
    }

    
}